import * as React from 'react';
import { TimeInput, TimeInputProps } from '../inputs/TimeInput';
import { FormField } from './FormField';

type TimeInputFieldProps = TimeInputProps & {
    label:string,
    infoMessage?:string,
    validator:(value:Date|null) => { valid:true } | {valid:false, errorMessage:string}
};

export function TimeInputField(props:TimeInputFieldProps)
{
    const validatorResult = props.validator(props.value);

    return (
        <FormField 
            label={props.label} 
            inputComponent={
                <div>
                    <TimeInput {...props} inErrorState={!validatorResult.valid} />
                </div>
            }
            inErrorState={!validatorResult.valid}
            message={validatorResult.valid===true ? props.infoMessage || '' : validatorResult.errorMessage}
        />
    )
}